import "./polyfill";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";// Styles
import "./css/style.css"
import AppExample from "./AppExample";
import { WalletProvider } from "@providers/wallet.provider";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <WalletProvider>
    <BrowserRouter>
      <App /> 
    </BrowserRouter>
  </WalletProvider>
);
